/** Where every envoy route begins. */
export const ENVOY_BASE = "/v1/envoy";
